import {AppConfig, BaseAppProps, BaseAppState} from "shared/BaseApp";
import React, {ReactElement} from 'react';
import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS, lightGray} from "../shared/colors";
import {Main} from "./Main";
import {PathComponent} from "../index";
import {FIREBASE_CONFIG} from "../consts";
import {BORDER_RADIUS, SZ_MD} from "../shared/dimens";
import {ProvisionedApp} from "../shared/ProvisionedApp";
import {ProvisionedAppConfig} from "../shared/types";

export type AppProps = BaseAppProps & {}

type AppState = BaseAppState & {}

export const COLOR_PRIMARY = "#000";

const FONT_FAMILY = "Bree Serif, serif";

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  components: {
    ...DEFAULT_THEME_OPTIONS.components,
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
          fontSize: "75%",
          borderRadius: BORDER_RADIUS,
        },
      }
    },
  },
  typography: {
    h1: {
      fontWeight: "bold",
      lineHeight: 1,
      fontFamily: FONT_FAMILY,
    },
    h2: {
      fontWeight: "bold",
      lineHeight: 1,
      fontFamily: FONT_FAMILY,
    },
    h3: {
      fontWeight: "bold",
      lineHeight: 1,
      fontFamily: FONT_FAMILY,
    },
    h4: {
      fontWeight: "bold",
      lineHeight: 1,
      fontFamily: FONT_FAMILY,
    },
    h5: {
      fontWeight: "bold",
      lineHeight: 1,
      fontFamily: FONT_FAMILY,
    },
    h6: {
      fontWeight: "bold",
      lineHeight: 1,
      fontFamily: FONT_FAMILY,
    },
    fontSize: 15,
  },
  palette: {
    background: {
      default: lightGray,
      paper: "white",
    },
    primary: {
      main: COLOR_PRIMARY,
      contrastText: "#fff",
    },
    secondary: {
      main: "#000",
      contrastText: "#fff",
    },
  }
};

export const THEME = createTheme(THEME_OPTIONS);

export class App extends ProvisionedApp<AppProps, AppState> {

  getProvisionedAppId(): string {
    return "bluemarble";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return null;
  }

  onCreateAppConfig(): AppConfig {
    return {
      name: "The Blue Marble",
      icon: "/icon.png",
      logo: "/logo192.png",
      stamp: "/stamp.png",
      stampHeight: SZ_MD,
      theme: THEME,
      loginConfig: {
        noLogin: true,
      },
      firebaseConfig: {options: FIREBASE_CONFIG},
    };
  }

  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  protected renderMain(): ReactElement {
    return <>
      <Main path={this.props.path}/>
    </>;
  }
}
